import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import AdminPage from "./pages/AdminPage";
import CatalogPage from "./pages/CatalogPage";
import KidsHomePage from "./pages/KidsHomePage";
import KidsTvPage from "./pages/KidsTvPage";
import LoginPage from "./pages/LoginPage";
import MoviesPage from "./pages/MoviesPage";
import ProfilesPage from "./pages/ProfilesPage";
import SettingsPage from "./pages/SettingsPage";
import { SagaDetailPage, SagasIndexPage } from "./pages/SagasPage";
import { SeriesDetailPage } from "./pages/SeriesPage";
import WatchPage from "./pages/WatchPage";
import IptvPage from "./pages/IptvPage";
import IptvWatchPage from "./pages/IptvWatchPage";
import RemotePage from "./pages/RemotePage";
import SearchPage from "./pages/SearchPage";
import AppsDownloadPage from "./pages/AppsDownloadPage";

function PrivateRoute({
  children,
  adminOnly = false,
  requireProfile = true,
  kidsOnly = false,
  adultOnly = false,
}) {
  const { token, user, isAdmin, profile, isKidsProfile } = useAuth();
  if (!token || !user) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  if (requireProfile && !profile) return <Navigate to="/profiles" replace />;
  if (kidsOnly && !isKidsProfile) return <Navigate to="/" replace />;
  if (adultOnly && isKidsProfile) return <Navigate to="/kids" replace />;
  return children;
}

const watchRoute = (
  <Route
    path="/watch/:id"
    element={
      <PrivateRoute>
        <WatchPage />
      </PrivateRoute>
    }
  />
);

export default function App() {
  const location = useLocation();
  const background = location.state?.background;

  return (
    <>
      <Routes location={background || location}>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/profiles"
          element={
            <PrivateRoute requireProfile={false}>
              <ProfilesPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/"
          element={
            <PrivateRoute adultOnly>
              <CatalogPage section="home" />
            </PrivateRoute>
          }
        />
        <Route
          path="/peliculas"
          element={
            <PrivateRoute adultOnly>
              <CatalogPage section="movie" />
            </PrivateRoute>
          }
        />
        <Route
          path="/peliculas/:genreSlug"
          element={
            <PrivateRoute adultOnly>
              <MoviesPage variant="movie" />
            </PrivateRoute>
          }
        />
        <Route
          path="/series"
          element={
            <PrivateRoute adultOnly>
              <MoviesPage variant="series" />
            </PrivateRoute>
          }
        />
        <Route
          path="/series/:slug"
          element={
            <PrivateRoute adultOnly>
              <SeriesDetailPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/anime"
          element={
            <PrivateRoute adultOnly>
              <MoviesPage variant="anime" />
            </PrivateRoute>
          }
        />
        <Route
          path="/anime/:genreSlug"
          element={
            <PrivateRoute adultOnly>
              <MoviesPage variant="anime" />
            </PrivateRoute>
          }
        />
        <Route
          path="/favoritos"
          element={
            <PrivateRoute adultOnly>
              <CatalogPage section="favorites" />
            </PrivateRoute>
          }
        />
        <Route
          path="/sagas"
          element={
            <PrivateRoute adultOnly>
              <SagasIndexPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/sagas/:slug"
          element={
            <PrivateRoute adultOnly>
              <SagaDetailPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute adultOnly>
              <SettingsPage />
            </PrivateRoute>
          }
        />
        <Route path="/apps" element={<AppsDownloadPage />} />
        <Route
          path="/buscar"
          element={
            <PrivateRoute adultOnly>
              <SearchPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/iptv"
          element={
            <PrivateRoute adultOnly>
              <IptvPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/iptv/:channelId"
          element={
            <PrivateRoute adultOnly>
              <IptvWatchPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/mando"
          element={
            <PrivateRoute adultOnly>
              <RemotePage />
            </PrivateRoute>
          }
        />
        {!background ? watchRoute : null}
        <Route
          path="/kids"
          element={
            <PrivateRoute kidsOnly>
              <KidsHomePage section="home" />
            </PrivateRoute>
          }
        />
        <Route
          path="/kids/peliculas"
          element={
            <PrivateRoute kidsOnly>
              <KidsHomePage section="movies" />
            </PrivateRoute>
          }
        />
        <Route
          path="/kids/series"
          element={
            <PrivateRoute kidsOnly>
              <KidsHomePage section="series" />
            </PrivateRoute>
          }
        />
        <Route
          path="/kids/anime"
          element={
            <PrivateRoute kidsOnly>
              <KidsHomePage section="anime" />
            </PrivateRoute>
          }
        />
        <Route
          path="/kids/favoritos"
          element={
            <PrivateRoute kidsOnly>
              <KidsHomePage section="favorites" />
            </PrivateRoute>
          }
        />
        <Route
          path="/kids/tv"
          element={
            <PrivateRoute kidsOnly>
              <KidsTvPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute adminOnly requireProfile={false} adultOnly>
              <AdminPage />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {background ? <Routes>{watchRoute}</Routes> : null}
    </>
  );
}
